import { Button, HStack, Icon } from '@chakra-ui/react'
import { Check } from 'lucide-react'

import {
  HospitalityRoomStatus,
  ROOM_STATUS_CONFIG,
} from '../../constants/roomStatuses'
import { useHotelsI18n } from '../../i18n'
import { getRoomStatusLabel } from './roomStatusLabels'

interface RoomStatusButtonsProps {
  currentStatus: HospitalityRoomStatus
  onStatusChange: (status: HospitalityRoomStatus) => void
  isDisabled?: boolean
}

const STATUS_ORDER = [
  HospitalityRoomStatus.DIRTY,
  HospitalityRoomStatus.CLEAN,
  HospitalityRoomStatus.OCCUPIED,
  HospitalityRoomStatus.INSPECTED,
] as const

export const RoomStatusButtons = ({
  currentStatus,
  onStatusChange,
  isDisabled = false,
}: RoomStatusButtonsProps) => {
  const { t } = useHotelsI18n()
  return (
    <HStack gap={2} flexWrap="wrap">
      {STATUS_ORDER.map((status) => {
        const config = ROOM_STATUS_CONFIG[status]
        const isActive = currentStatus === status
        return (
          <Button
            key={status}
            size="sm"
            variant="outline"
            borderRadius="lg"
            borderWidth={1}
            bg={{
              base: isActive ? config.subtleBg : `${config.colorPalette}.50`,
              _dark: isActive
                ? config.subtleBgDark
                : `${config.colorPalette}.900`,
            }}
            borderColor={{
              base: isActive ? config.border : config.subtleBorder,
              _dark: isActive ? config.borderDark : config.subtleBorderDark,
            }}
            color={{ base: config.text, _dark: config.textDark }}
            _hover={{
              bg: {
                base: isActive ? config.subtleBg : config.subtleBg,
                _dark: isActive
                  ? config.subtleBgDark
                  : `${config.colorPalette}.900`,
              },
            }}
            fontWeight={isActive ? 'bold' : 'normal'}
            aria-pressed={isActive}
            onClick={() => {
              if (isActive) return
              onStatusChange(status)
            }}
            disabled={isDisabled}
          >
            {isActive && <Icon as={Check} boxSize={4} aria-hidden />}
            {getRoomStatusLabel(status, t)}
          </Button>
        )
      })}
    </HStack>
  )
}
